import { unifiedAuthLoginUrl } from '@/api/user'
import defaultSettings from '@/settings'

/**
 * 统一身份认证平台对接。
 *
 * 登录页或实际承接认证回调的业务页面均可引入该 mixin，页面本身只需决定
 * 认证成功后的跳转或业务动作，认证参数解析、令牌交换和退出逻辑统一维护在此处。
 */
export default {
	data() {
		return {
			unifiedAuthLoading: false,
			unifiedAuthError: null
		}
	},
	computed: {
		isUnifiedAuthenticated() {
			return Boolean(this.$store.state.user.token && this.$store.state.user.realName)
		}
	},
	methods: {
		// 解析统一身份认证平台回调参数
		parseUnifiedAuthCallbackParams() {
			const searchParams = new URLSearchParams(window.location.search)
			return {
				userCode: searchParams.get('userCode') || '',
				sessionId: searchParams.get('sessionId') || '',
				error: searchParams.get('error') || '',
				message: searchParams.get('message') || '',
				captchaId: searchParams.get('captchaId') || ''
			}
		},
		// 使用认证平台令牌换取楚建通用户登录信息
		async exchangeUnifiedAuthTokenForUserInfo(authParams) {
			try {
				this.unifiedAuthLoading = true
				this.unifiedAuthError = null
				await this.$store.dispatch('user/unifiedAuthLogin', authParams)
				await this.$store.dispatch('user/getUserInfo')
				return true
			} catch (error) {
				this.unifiedAuthError = (error && error.message) || '获取用户信息失败'
				return false
			} finally {
				this.unifiedAuthLoading = false
			}
		},
		// 处理统一身份认证错误
		handleUnifiedAuthError(errorMessage, errorCode) {
			this.unifiedAuthError = errorMessage
			this.$message.error(errorMessage)
			console.error('统一身份认证失败:', errorCode, errorMessage)
		},
		// 清除回调参数，避免刷新页面后重复处理令牌
		clearUnifiedAuthCallbackParams() {
			const url = new URL(window.location.href)
			;['userCode', 'sessionId', 'error', 'message', 'captchaId'].forEach(key => {
				url.searchParams.delete(key)
			})
			window.history.replaceState({}, '', url.toString())
		},
		// 处理统一身份认证平台回调
		async handleUnifiedAuthCallback() {
			const params = this.parseUnifiedAuthCallbackParams()

			if (params.error) {
				this.handleUnifiedAuthError(params.message || '统一身份认证失败', params.error)
				this.clearUnifiedAuthCallbackParams()
				return false
			}

			const success = await this.exchangeUnifiedAuthTokenForUserInfo({
				userCode: params.userCode,
				sessionId: params.sessionId,
				captchaId: params.captchaId
			})

			this.clearUnifiedAuthCallbackParams()
			if (success) {
				this.$message.success('登录成功')
			}
			return success
		},
		// 后端提供的是可直接访问的跳转地址，不发起 Ajax 请求
		redirectToUnifiedAuthLogin() {
			window.location.href = unifiedAuthLoginUrl()
		},
		// 统一身份认证退出；普通账号在没有 sessionId 时只清理楚建通本地登录态
		async unifiedAuthLogout(goBack) {
			const sessionId = this.$store.state.user.sessionId
			const fallbackUrl = goBack || window.location.origin + defaultSettings.publicPath + 'login'
			console.log('sessionId', sessionId)
			console.log('fallbackUrl', fallbackUrl)

			await this.$store.dispatch('user/logout')

			if (sessionId) {
				// 统一身份认证平台退出地址
				window.location.href = `https://oauth.hubei.gov.cn:8443/uias/uias/LogOut?sessionId=${sessionId}&goBack=${fallbackUrl}`
				return
			}

			window.location.href = fallbackUrl
		},
		// 供任意实际回调承载页面在 mounted/created 中初始化
		initUnifiedAuthCallback() {
			const params = this.parseUnifiedAuthCallbackParams()
			console.log('params', params)

			if (params.userCode || params.error) {
				return this.handleUnifiedAuthCallback()
			}
			return Promise.resolve(false)
		}
	}
}
